import { ReactNode } from "react";

import style from "./productVariantAttribute.module.scss";

function ProductVariantAttribute({ atributeName, atributeValue, action, children }: ProductVariantAttributeProps) {
  return (
    <div className={style.ProductVariantAttribute}>
      <div className={style.header}>
        <span className={style.headerName}>{atributeName}:</span>
        <span className={style.headerValue}>{atributeValue}</span>
        {action ? <div className={style.headerAction}>{action}</div> : null}
      </div>
      {children}
    </div>
  );
}

type ProductVariantAttributeProps = {
  atributeName: string;
  atributeValue: string;
  action?: ReactNode;
  children?: ReactNode;
};

export default ProductVariantAttribute;
